import Vue from 'vue'
import alertacmp from '../components/alerta.component.vue'
let idElemForm = '#alerta-form';
const vueApp = document.querySelector(idElemForm);
if (vueApp) {
    let canalComponent = new Vue({
        el: idElemForm,
        created: () => {
        },
        data: () => ({}),
        components: {
            'el-alerta': alertacmp
        }
    });
}
